import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import ContactUs from './components/ContactUs';
import SystemRequirements from './components/SystemRequirements';
import HowItWorks from './components/HowItWorks';
import WhoAreWe from './components/WhoAreWe';
import Footer from './components/Footer';
import FleetEfficiency from './components/FleetEfficiency';


const homePage = () => (
  <div>
    <Header />
    <HeroSection />
    <Services />
    <HowItWorks />
    <WhoAreWe />
    {/* <SystemRequirements/> */}
    <FleetEfficiency />
    <ContactUs />
    <Footer />
  </div>
);

export default homePage;

